import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatTableModule } from '@angular/material/table';

import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { LocaleSelectComponent } from './locale-select/locale-select.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LoadingDialogService } from './loading/loading-dialog.service';
import { SearchComponent } from './search/search.component';
import { TableRowComponent } from './table-row/table-row.component';
import { MatMenuModule } from '@angular/material/menu';
import { DrawerComponent } from './drawer/drawer.component';
import { SnackbarComponent } from './snackbar/snackbar.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DialogContentComponent } from './dialog-content/dialog-content.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ErrorDialogService } from './errors/error-dialog.service';
import { TextWithLogoComponent } from './text-with-logo/text-with-logo.component';
import { LoadingDialogComponent } from './loading/loading-dialog/loading-dialog.component';
import { ErrorDialogComponent } from './errors/error-dialog/error-dialog.component';
import { TokenExpirationDialogComponent } from './token-expiration-dialog/token-expiration-dialog.component';


const sharedComponents = [
    LocaleSelectComponent,
    SearchComponent,
    TableRowComponent,
    DialogContentComponent,
    DrawerComponent,
    SnackbarComponent,
    TextWithLogoComponent,
    LoadingDialogComponent,
    ErrorDialogComponent,
    TokenExpirationDialogComponent
];

@NgModule({
    declarations: [...sharedComponents],
    imports: [
        CommonModule,
        MatTableModule,
        MatTreeModule,
        MatIconModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        RouterModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatDialogModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatSelectModule,
        FlexLayoutModule,
        FormsModule,
        MatMenuModule,
        MatSnackBarModule,
        MatChipsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressSpinnerModule
    ],
    exports: [...sharedComponents],
    providers: [ErrorDialogService, LoadingDialogService],

})
export class ComponentsModule {}
